webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(173);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(165);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(144);
	
	__webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 5:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(127);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(125);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(126);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rifewave = __webpack_require__(118);
	
	var _rifewave2 = _interopRequireDefault(_rifewave);
	
	var _morseNode = __webpack_require__(4);
	
	var _morseNode2 = _interopRequireDefault(_morseNode);
	
	var _lodash = __webpack_require__(153);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MorseWave = function () {
	  function MorseWave(morseCodes) {
	    (0, _classCallCheck3.default)(this, MorseWave);
	
	    if (!_morseNode2.default.create('ITU').isValid(morseCodes, 'morse')) {
	      throw new Error('Error: MorseWave constructor\'s argument must be morse code');
	    }
	
	    this._morseCodes = morseCodes.trim();
	    this._wpm = 20;
	    this._fwpm = 20;
	    this._sampleRate = 8000;
	    this._frequency = 550;
	
	    var data = this.GetPCMData();
	    this.wave = new _rifewave2.default(data);
	  }
	
	  (0, _createClass3.default)(MorseWave, [{
	    key: 'GetTimings',
	    value: function GetTimings() {
	      var _code2TimeHash;
	
	      var dit = '.';
	      var dah = '-';
	      var signalSpace = 'signalSpace';
	      var charSpace = ' ';
	      var wordSpace = '/';
	      var r = this.Wpm / this.Fwpm;
	      var ditPerWord = 50;
	      var ditTime = 50000 / (ditPerWord * this.Wpm);
	      var dahTime = ditTime * 3;
	      var signalSpaceTime = ditTime;
	      var charSpaceTime = ditTime * 3 * r;
	      var wordSpaceTime = ditTime * 7 * r;
	
	      var codes = this._morseCodes;
	      var times = [];
	      var code2TimeHash = (_code2TimeHash = {}, (0, _defineProperty3.default)(_code2TimeHash, dit, ditTime), (0, _defineProperty3.default)(_code2TimeHash, dah, dahTime), (0, _defineProperty3.default)(_code2TimeHash, signalSpace, -signalSpaceTime), (0, _defineProperty3.default)(_code2TimeHash, charSpace, -charSpaceTime), (0, _defineProperty3.default)(_code2TimeHash, wordSpace, -wordSpaceTime), _code2TimeHash);
	
	      for (var i = 0; i < codes.length; i++) {
	        var previousCode = codes[i - 1];
	        var code = codes[i];
	
	        if (i > 0 && [dit, dah].includes(code) && [dit, dah].includes(previousCode)) {
	          times.push(code2TimeHash[signalSpace]);
	        }
	
	        if ([dit, dah, charSpace, wordSpace].includes(code)) {
	          times.push(code2TimeHash[code]);
	        }
	      }
	      return times;
	    }
	  }, {
	    key: 'GetPCMData',
	    value: function GetPCMData() {
	      var timings = this.GetTimings();
	      if (timings.length === 0) {
	        return [];
	      }
	
	      var data = [];
	      var samples = {};
	
	      for (var i = 0; i < timings.length; i++) {
	        var key = timings[i];
	        var isSpace = timings[i] < 1;
	        var seconds = Math.abs(timings[i] * 0.001);
	        var sampleNumber = Math.round(this.SampleRate * seconds);
	
	        if (_lodash2.default.has(samples, key)) {
	          data.push(samples[key]);
	          continue;
	        }
	
	        var sample = [];
	        if (isSpace) {
	          sample = this.GenerateEmptySignal(sampleNumber);
	          data.push(sample);
	          samples[key] = sample;
	          continue;
	        }
	
	        sample = this.GenerateSignal(sampleNumber);
	        samples[key] = sample;
	        data.push(sample);
	      }
	
	      return [].concat.apply([], data);
	    }
	  }, {
	    key: 'GetWav',
	    value: function GetWav() {
	      return this.wave.wav;
	    }
	  }, {
	    key: 'GetDataURI',
	    value: function GetDataURI() {
	      return this.wave.dataURI;
	    }
	  }, {
	    key: 'GenerateSignal',
	    value: function GenerateSignal(sampleNumber) {
	      var counterIncrementAmount = Math.PI * 2 * this.Frequency / this.SampleRate;
	      var signal = [];
	
	      for (var j = 0; j < sampleNumber; j += 1) {
	        var rawData = Math.sin(j * counterIncrementAmount);
	        var pcmData = 128 + Math.round(127 * rawData);
	
	        signal.push(pcmData);
	      }
	
	      return signal;
	    }
	  }, {
	    key: 'GenerateEmptySignal',
	    value: function GenerateEmptySignal(sampleNumber) {
	      return new Array(sampleNumber).fill(128);
	    }
	  }, {
	    key: 'Wpm',
	    get: function get() {
	      return this._wpm;
	    },
	    set: function set(wpm) {
	      this._wpm = wpm;
	      if (wpm < this._fwpm) {
	        this._fwpm = wpm;
	      }
	    }
	  }, {
	    key: 'Fwpm',
	    get: function get() {
	      return this._fwpm;
	    },
	    set: function set(fwpm) {
	      this._fwpm = fwpm;
	      if (fwpm > this._wpm) {
	        this._wpm = fwpm;
	      }
	    }
	  }, {
	    key: 'SampleRate',
	    get: function get() {
	      return this._sampleRate;
	    },
	    set: function set(sampleRate) {
	      if (sampleRate === this._sampleRate) return;
	      if (sampleRate * 0.5 <= this.Frequency) {
	        this.Frequency = sampleRate * 0.5;
	      }
	      this._sampleRate = sampleRate;
	    }
	  }, {
	    key: 'Frequency',
	    get: function get() {
	      return this._frequency;
	    },
	    set: function set(frequency) {
	      if (frequency === this._frequency) return;
	      if (this.SampleRate * 0.5 <= frequency) {
	        this.SampleRate = frequency * 2;
	      }
	      this._frequency = frequency;
	    }
	  }]);
	  return MorseWave;
	}();
	
	exports.default = MorseWave;

/***/ },

/***/ 118:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var FastBase64 = {
	
	  chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	  encLookup: [],
	
	  Init: function Init() {
	    for (var i = 0; i < 4096; i++) {
	      this.encLookup[i] = this.chars[i >> 6] + this.chars[i & 0x3F];
	    }
	  },
	
	  Encode: function Encode(src) {
	    var len = src.length;
	    var dst = '';
	    var i = 0;
	    while (len > 2) {
	      var n = src[i] << 16 | src[i + 1] << 8 | src[i + 2];
	      dst += this.encLookup[n >> 12] + this.encLookup[n & 0xFFF];
	      len -= 3;
	      i += 3;
	    }
	    if (len > 0) {
	      var n1 = (src[i] & 0xFC) >> 2;
	      var n2 = (src[i] & 0x03) << 4;
	      if (len > 1) {
	        n2 |= (src[++i] & 0xF0) >> 4;
	      }
	      dst += this.chars[n1];
	      dst += this.chars[n2];
	      if (len === 2) {
	        var n3 = (src[i++] & 0x0F) << 2;
	        n3 |= (src[i] & 0xC0) >> 6;
	        dst += this.chars[n3];
	      }
	      if (len === 1) {
	        dst += '=';
	      }
	      dst += '=';
	    }
	    return dst;
	  } };
	
	FastBase64.Init();
	
	var RIFFWAVE = function RIFFWAVE(data) {
	  this.data = [];
	  this.wav = [];
	  this.dataURI = '';
	
	  this.header = {
	    chunkId: [0x52, 0x49, 0x46, 0x46],
	    chunkSize: 0,
	    format: [0x57, 0x41, 0x56, 0x45],
	    subChunk1Id: [0x66, 0x6d, 0x74, 0x20],
	    subChunk1Size: 16,
	    audioFormat: 1,
	    numChannels: 1,
	    sampleRate: 8000,
	    byteRate: 0,
	    blockAlign: 0,
	    bitsPerSample: 8,
	    subChunk2Id: [0x64, 0x61, 0x74, 0x61],
	    subChunk2Size: 0 };
	
	  function u32ToArray(i) {
	    return [i & 0xFF, i >> 8 & 0xFF, i >> 16 & 0xFF, i >> 24 & 0xFF];
	  }
	
	  function u16ToArray(i) {
	    return [i & 0xFF, i >> 8 & 0xFF];
	  }
	
	  function split16bitArray(data) {
	    var r = [];
	    var j = 0;
	    var len = data.length;
	    for (var i = 0; i < len; i++) {
	      r[j++] = data[i] & 0xFF;
	      r[j++] = data[i] >> 8 & 0xFF;
	    }
	    return r;
	  }
	
	  this.Make = function (data) {
	    if (data instanceof Array) this.data = data;
	    this.header.blockAlign = this.header.numChannels * this.header.bitsPerSample >> 3;
	    this.header.byteRate = this.header.blockAlign * this.sampleRate;
	    this.header.subChunk2Size = this.data.length * (this.header.bitsPerSample >> 3);
	    this.header.chunkSize = 36 + this.header.subChunk2Size;
	
	    this.wav = this.header.chunkId.concat(u32ToArray(this.header.chunkSize), this.header.format, this.header.subChunk1Id, u32ToArray(this.header.subChunk1Size), u16ToArray(this.header.audioFormat), u16ToArray(this.header.numChannels), u32ToArray(this.header.sampleRate), u32ToArray(this.header.byteRate), u16ToArray(this.header.blockAlign), u16ToArray(this.header.bitsPerSample), this.header.subChunk2Id, u32ToArray(this.header.subChunk2Size), this.header.bitsPerSample === 16 ? split16bitArray(this.data) : this.data);
	    this.dataURI = 'data:audio/wav;base64,' + FastBase64.Encode(this.wav);
	  };
	
	  if (data instanceof Array) this.Make(data);
	};exports.default = RIFFWAVE;

/***/ },

/***/ 119:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(171);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Coder = __webpack_require__(168);
	
	var _Coder2 = _interopRequireDefault(_Coder);
	
	var _Introduction = __webpack_require__(172);
	
	var _Introduction2 = _interopRequireDefault(_Introduction);
	
	var _CodeTables = __webpack_require__(167);
	
	var _CodeTables2 = _interopRequireDefault(_CodeTables);
	
	var _Footer = __webpack_require__(170);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TheHead: _Header2.default,
	    Introduction: _Introduction2.default,
	    CodeTables: _CodeTables2.default,
	    Coder: _Coder2.default,
	    TheFoot: _Footer2.default
	  }
	};

/***/ },

/***/ 120:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'subtitle', 'codes', 'Encode', 'Play']
	};

/***/ },

/***/ 121:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Codes = __webpack_require__(169);
	
	var _Codes2 = _interopRequireDefault(_Codes);
	
	var _CodeTable = __webpack_require__(166);
	
	var _CodeTable2 = _interopRequireDefault(_CodeTable);
	
	var _MorseWave = __webpack_require__(5);
	
	var _MorseWave2 = _interopRequireDefault(_MorseWave);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var morse = __webpack_require__(4).create('ITU');
	
	exports.default = {
	  components: {
	    Codes: _Codes2.default,
	    CodeTable: _CodeTable2.default
	  },
	  data: function data() {
	    return {
	      alphabets: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
	      numbers: '1234567890'.split(''),
	      symbols: '.:,;?=\'/!-_"()$&@+'.split('')
	    };
	  },
	  methods: {
	    Encode: function Encode(text) {
	      return morse.encode(text);
	    },
	    Play: function Play(morseCode) {
	      var wave = new _MorseWave2.default(morseCode);
	      var audio = document.createElement('audio');
	      audio.src = wave.GetDataURI();
	      audio.play();
	    }
	  }
	};

/***/ },

/***/ 122:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MorseWave = __webpack_require__(5);
	
	var _MorseWave2 = _interopRequireDefault(_MorseWave);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var morse = __webpack_require__(4).create('ITU');
	var Clipboard = __webpack_require__(129);
	
	var validDit = /[·・．。]/g;
	var validDah = /[_＿－]/g;
	
	var GetNowDateFormate = function GetNowDateFormate() {
	  return (0, _moment2.default)().format('YYYY-MM-DD HH:mm:ss');
	};
	
	new Clipboard('.copy.button');
	
	exports.default = {
	  data: function data() {
	    return {
	      placeholder: '您可以在文字框裡輸入本頁下方所列出的英數字元與符號、摩斯訊號符號進行編、解碼。當您輸入的文字、符號是符合規則的內容時，文字框下方的編碼、解碼按鈕就可以點擊。',
	      input: '',
	      output: '',
	      isInputValid: true,
	      isInputMorse: false,
	      isInputChars: false,
	      records: []
	    };
	  },
	  methods: {
	    Encode: function Encode() {
	      if (morse.isValid(this.input, 'chars')) {
	        this.isInputValid = true;
	        this.output = morse.encode(this.input);
	        this.records.unshift({
	          text: this.input,
	          code: this.output,
	          time: GetNowDateFormate(),
	          audio: null,
	          IsPlaying: false
	        });
	        return;
	      }
	
	      this.isInputValid = false;
	      this.output = 'Error! Invalid text.';
	    },
	    Decode: function Decode() {
	      var code = this.input.replace(validDit, '.').replace(validDah, '-');
	      if (morse.isValid(code, 'morse')) {
	        this.isInputValid = true;
	        this.output = morse.decode(code);
	        this.records.unshift({
	          text: this.output,
	          code: code,
	          time: GetNowDateFormate(),
	          audio: null,
	          IsPlaying: false
	        });
	        return;
	      }
	
	      this.isInputValid = false;
	      this.output = 'Error! Invalid morse code.';
	    },
	    Reset: function Reset() {
	      this.input = '';
	    },
	    JudgeInput: function JudgeInput() {
	      var msg = this.input;
	      this.isInputChars = morse.isValid(msg, 'chars');
	
	      var code = this.input.replace(validDit, '.').replace(validDah, '-');
	      this.isInputMorse = morse.isValid(code, 'morse');
	    },
	    Play: function Play(record) {
	      if (record.IsPlaying) {
	        record.audio.pause();
	        record.audio.currentTime = 0;
	        record.IsPlaying = false;
	        return;
	      }
	
	      if (!record.audio) {
	        var morseCode = morse.encode(record.text);
	        var wave = new _MorseWave2.default(morseCode);
	
	        record.audio = document.createElement('audio');
	        record.audio.src = wave.GetDataURI();
	        record.audio.addEventListener('playing', function () {
	          record.IsPlaying = true;
	        });
	        record.audio.addEventListener('ended', function () {
	          record.IsPlaying = false;
	        });
	      }
	
	      record.audio.play();
	    }
	  }
	};

/***/ },

/***/ 123:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['Play']
	};

/***/ },

/***/ 124:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  methods: {}
	};

/***/ },

/***/ 143:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 144:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 145:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 146:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 147:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 148:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 149:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 150:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 154:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 13,
		"./af.js": 13,
		"./ar": 18,
		"./ar-ly": 14,
		"./ar-ly.js": 14,
		"./ar-ma": 15,
		"./ar-ma.js": 15,
		"./ar-sa": 16,
		"./ar-sa.js": 16,
		"./ar-tn": 17,
		"./ar-tn.js": 17,
		"./ar.js": 18,
		"./az": 19,
		"./az.js": 19,
		"./be": 20,
		"./be.js": 20,
		"./bg": 21,
		"./bg.js": 21,
		"./bn": 22,
		"./bn.js": 22,
		"./bo": 23,
		"./bo.js": 23,
		"./br": 24,
		"./br.js": 24,
		"./bs": 25,
		"./bs.js": 25,
		"./ca": 26,
		"./ca.js": 26,
		"./cs": 27,
		"./cs.js": 27,
		"./cv": 28,
		"./cv.js": 28,
		"./cy": 29,
		"./cy.js": 29,
		"./da": 30,
		"./da.js": 30,
		"./de": 32,
		"./de-at": 31,
		"./de-at.js": 31,
		"./de.js": 32,
		"./dv": 33,
		"./dv.js": 33,
		"./el": 34,
		"./el.js": 34,
		"./en-au": 35,
		"./en-au.js": 35,
		"./en-ca": 36,
		"./en-ca.js": 36,
		"./en-gb": 37,
		"./en-gb.js": 37,
		"./en-ie": 38,
		"./en-ie.js": 38,
		"./en-nz": 39,
		"./en-nz.js": 39,
		"./eo": 40,
		"./eo.js": 40,
		"./es": 42,
		"./es-do": 41,
		"./es-do.js": 41,
		"./es.js": 42,
		"./et": 43,
		"./et.js": 43,
		"./eu": 44,
		"./eu.js": 44,
		"./fa": 45,
		"./fa.js": 45,
		"./fi": 46,
		"./fi.js": 46,
		"./fo": 47,
		"./fo.js": 47,
		"./fr": 50,
		"./fr-ca": 48,
		"./fr-ca.js": 48,
		"./fr-ch": 49,
		"./fr-ch.js": 49,
		"./fr.js": 50,
		"./fy": 51,
		"./fy.js": 51,
		"./gd": 52,
		"./gd.js": 52,
		"./gl": 53,
		"./gl.js": 53,
		"./he": 54,
		"./he.js": 54,
		"./hi": 55,
		"./hi.js": 55,
		"./hr": 56,
		"./hr.js": 56,
		"./hu": 57,
		"./hu.js": 57,
		"./hy-am": 58,
		"./hy-am.js": 58,
		"./id": 59,
		"./id.js": 59,
		"./is": 60,
		"./is.js": 60,
		"./it": 61,
		"./it.js": 61,
		"./ja": 62,
		"./ja.js": 62,
		"./jv": 63,
		"./jv.js": 63,
		"./ka": 64,
		"./ka.js": 64,
		"./kk": 65,
		"./kk.js": 65,
		"./km": 66,
		"./km.js": 66,
		"./ko": 67,
		"./ko.js": 67,
		"./ky": 68,
		"./ky.js": 68,
		"./lb": 69,
		"./lb.js": 69,
		"./lo": 70,
		"./lo.js": 70,
		"./lt": 71,
		"./lt.js": 71,
		"./lv": 72,
		"./lv.js": 72,
		"./me": 73,
		"./me.js": 73,
		"./mi": 74,
		"./mi.js": 74,
		"./mk": 75,
		"./mk.js": 75,
		"./ml": 76,
		"./ml.js": 76,
		"./mr": 77,
		"./mr.js": 77,
		"./ms": 79,
		"./ms-my": 78,
		"./ms-my.js": 78,
		"./ms.js": 79,
		"./my": 80,
		"./my.js": 80,
		"./nb": 81,
		"./nb.js": 81,
		"./ne": 82,
		"./ne.js": 82,
		"./nl": 83,
		"./nl.js": 83,
		"./nn": 84,
		"./nn.js": 84,
		"./pa-in": 85,
		"./pa-in.js": 85,
		"./pl": 86,
		"./pl.js": 86,
		"./pt": 88,
		"./pt-br": 87,
		"./pt-br.js": 87,
		"./pt.js": 88,
		"./ro": 89,
		"./ro.js": 89,
		"./ru": 90,
		"./ru.js": 90,
		"./se": 91,
		"./se.js": 91,
		"./si": 92,
		"./si.js": 92,
		"./sk": 93,
		"./sk.js": 93,
		"./sl": 94,
		"./sl.js": 94,
		"./sq": 95,
		"./sq.js": 95,
		"./sr": 97,
		"./sr-cyrl": 96,
		"./sr-cyrl.js": 96,
		"./sr.js": 97,
		"./ss": 98,
		"./ss.js": 98,
		"./sv": 99,
		"./sv.js": 99,
		"./sw": 100,
		"./sw.js": 100,
		"./ta": 101,
		"./ta.js": 101,
		"./te": 102,
		"./te.js": 102,
		"./th": 103,
		"./th.js": 103,
		"./tl-ph": 104,
		"./tl-ph.js": 104,
		"./tlh": 105,
		"./tlh.js": 105,
		"./tr": 106,
		"./tr.js": 106,
		"./tzl": 107,
		"./tzl.js": 107,
		"./tzm": 109,
		"./tzm-latn": 108,
		"./tzm-latn.js": 108,
		"./tzm.js": 109,
		"./uk": 110,
		"./uk.js": 110,
		"./uz": 111,
		"./uz.js": 111,
		"./vi": 112,
		"./vi.js": 112,
		"./x-pseudo": 113,
		"./x-pseudo.js": 113,
		"./zh-cn": 114,
		"./zh-cn.js": 114,
		"./zh-hk": 115,
		"./zh-hk.js": 115,
		"./zh-tw": 116,
		"./zh-tw.js": 116
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 154;


/***/ },

/***/ 157:
/***/ function(module, exports) {

	module.exports = " <the-head></the-head> <coder></coder> <introduction></introduction> <code-tables></code-tables> <the-foot></the-foot> ";

/***/ },

/***/ 158:
/***/ function(module, exports) {

	module.exports = " <section> <h3 class=title>{{ title }}</h3> <h3 class=subtitle>{{ subtitle }}</h3> <div class=\"columns is-gapless is-multiline is-mobile\"> <div class=code v-for=\"code in codes\" @click=Play(Encode(code))> <p class=heading>{{Encode(code)}}</p> <p class=title>{{code}}</p> </div> </div> </section> ";

/***/ },

/***/ 159:
/***/ function(module, exports) {

	module.exports = " <section class=section> <div class=container> <div class=heading> <h2 class=\"title is-2\">Table</h2> <h2 class=\"subtitle is-4\"> 摩斯電碼對照表 </h2> <p class=\"subtitle is-6\">點擊字母或符號，會播放對應的摩斯電碼音效。</p> </div> <code-table title=Alphabets subtitle=英文字母 :codes=alphabets :encode=Encode :play=Play></code-table> <code-table title=Numbers subtitle=數字 :codes=numbers :encode=Encode :play=Play></code-table> <code-table title=Symbols subtitle=符號 :codes=symbols :encode=Encode :play=Play></code-table> <codes :play=Play></codes> </div> </section> ";

/***/ },

/***/ 160:
/***/ function(module, exports) {

	module.exports = " <section id=coder class=section> <div class=container> <div class=heading> <h1 class=\"title is-2\">Codec</h1> <h2 class=\"subtitle is-4\">編/解碼器</h2> </div> <section> <div class=control> <textarea id=input-box class=\"textarea is-medium\" v-bind:class=\"{ 'is-danger': !isInputValid }\" v-model=input v-on:keyup=JudgeInput placeholder={{placeholder}}></textarea> <span class=\"help is-danger\" v-show=!isInputValid>欄位不得為空</span> </div> <div class=control> <button class=\"button is-primary\" @click=Encode v-bind:class=\"{ 'is-disabled': !isInputChars}\">編碼 / Encode</button> <button class=\"button is-primary\" @click=Decode v-bind:class=\"{ 'is-disabled': !isInputMorse}\">解碼 / Decode</button> <button class=button @click=Reset>清除 / Clear</button> </div> </section> <section> <h1 class=title>Records</h1> <h2 class=subtitle> 查詢紀錄 </h2> <p class=control v-show=\"records.length === 0\"> 尚無紀錄 </p> <p class=control v-show=\"records.length > 0\"> 點擊紀錄的藍色標題橫槓，可以播放該訊息摩斯電碼的音效。 </p> <article class=message v-for=\"record in records\" v-bind:class=\"{\n                  'is-info': !record.IsPlaying,\n                  'is-success': record.IsPlaying,\n                }\"> <div class=message-header @click=Play(record)> <div class=columns> <div class=\"column is-half\"> # {{records.length - $index}} </div> <div class=\"column is-half has-text-right\"> {{record.time}} </div> </div> </div> <div class=message-body> <div class=columns> <div class=\"column is-half\"> <div class=\"notification is-code\"> <a class=\"copy button is-small is-outlined\" data-clipboard-target=#record-{{$index}}-text> <span>Copy</span> <span class=\"icon is-small\"> <i class=\"fa fa-copy\"></i> </span> </a> <span id=record-{{$index}}-text> {{record.text}} </span> </div> </div> <div class=\"column is-half\"> <p class=\"notification is-code\"> <a class=\"copy button is-small is-outlined\" data-clipboard-target=#record-{{$index}}-code> <span>Copy</span> <span class=\"icon is-small\"> <i class=\"fa fa-copy\"></i> </span> </a> <code id=record-{{$index}}-code class=morse-code>{{record.code}}</code> </p> </div> </div> </div> </article> </section> </div> </section> ";

/***/ },

/***/ 161:
/***/ function(module, exports) {

	module.exports = " <section> <div class=container> <div class=heading> <h2 class=\"title is-3\">Codes</h2> <h2 class=\"subtitle is-5\"> 摩斯電碼 </h2> </div> <p class=control> 本節會列出本站解碼器所支援的摩斯訊號字元 </p> <section> <h3 class=\"title is-4\">Dit</h3> <h3 class=\"subtitle is-6\">短音</h3> <div class=\"columns is-gapless is-multiline is-mobile\"> <div class=code @click=\"Play('.')\"> <p class=heading title=dot>半形句點</p> <p class=title>.</p> </div> <div class=code @click=\"Play('.')\"> <p class=heading>半形間隔號</p> <p class=title>·</p> </div> <div class=code @click=\"Play('.')\"> <p class=heading>全形間隔號</p> <p class=title>・</p> </div> <div class=code @click=\"Play('.')\"> <p class=heading>西式句點</p> <p class=title>．</p> </div> <div class=code @click=\"Play('.')\"> <p class=heading>中式句點</p> <p class=title>。</p> </div> </div> </section> <section> <h3 class=\"title is-4\">Dah</h3> <h3 class=\"subtitle is-6\">長音</h3> <p class=control> 長音的長度為短音的三倍。 </p> <div class=\"columns is-gapless is-multiline is-mobile\"> <div class=code @click=\"Play('-')\"> <p class=heading title=dash>半形破折號</p> <p class=title>-</p> </div> <div class=code @click=\"Play('-')\"> <p class=heading title=underscore>底線</p> <p class=title>_</p> </div> <div class=code @click=\"Play('-')\"> <p class=heading>全形底線</p> <p class=title>＿</p> </div> <div class=code @click=\"Play('-')\"> <p class=heading>連字號</p> <p class=title>－</p> </div> </div> </section> <section> <h3 class=\"title is-4\">Space</h3> <h3 class=\"subtitle is-6\">間隔</h3> <p class=control> 間格主要分為三種，第一種是長短音之間的間隔，長度與短音相同；第二種是字元之間的間隔 (space)，長度是短音的三倍；第三就是單詞之間的間隔 (slash)，長度為短音的七倍。 </p> <div class=\"columns is-gapless is-multiline is-mobile\"> <div class=code @click=\"Play(' ')\"> <p class=heading title=space>空格</p> <p class=title>&nbsp;</p> </div> <div class=code @click=\"Play('/')\"> <p class=heading title=slash>斜線</p> <p class=title>/</p> </div> </div> </section> </div> </section> ";

/***/ },

/***/ 162:
/***/ function(module, exports) {

	module.exports = " <footer class=footer> <div class=container> <div class=\"content has-text-centered\"> <p> <strong>Morse Code</strong> by <a href=http://fntsr.tw target=_blank>Ruoshi Lin</a>. Powered by <a href=http://bulma.io target=_blank>BULMA</a> & <a href=https://vuejs.org target=_blank>Vue.js</a> <br/> The source code is licensed <a href=http://opensource.org/licenses/mit-license.php>MIT</a>. The website content is licensed <a href=http://creativecommons.org/licenses/by-nc-sa/4.0/ >CC ANS 4.0</a>. </p> <p> <a class=icon href=https://github.com/fntsrlike/Morse-Code target=_blank> <i class=\"fa fa-github\"></i> </a> </p> </div> </div> </footer> ";

/***/ },

/***/ 163:
/***/ function(module, exports) {

	module.exports = " <section class=\"hero is-primary\"> <div class=hero-body> <div class=container> <h1 class=title> Morse Code </h1> <h2 class=subtitle> 摩斯電碼編解碼工具 </h2> </div> </div> </section> ";

/***/ },

/***/ 164:
/***/ function(module, exports) {

	module.exports = " <section id=introduction class=\"section is-medium\"> <div class=container> <div class=heading> <h2 class=\"title is-2\">Introduction</h2> <h2 class=\"subtitle is-4\"> 關於摩斯電碼 </h2> </div> <div class=\"content is-medium\"> <section> <p> 每個摩斯電碼，無論是文字字元 (字母、數字) 或是符號都會以相異的<b>長、短音</b>序列去呈現。在時間長度上，通常以短音的時間作為標準，長音的時間會是短音時間的三倍，每個長短音之間都會以一個和短音相同時間間隔的停頓去區隔，每個字元、符號之間則是以三倍短音時間的停頓區隔，而每個單詞（word）則是以七倍短音時間的停頓區隔。 </p> <p> 而為了提高通訊的速度，在設計字元的摩斯電碼序列時，會去參考該字元在英文裡出現的頻率做考量，若是越常出現的字元，序列就會越短。就像是英文裡最通用的字元 <code>E</code>，就只使用一個短音做表示。另外為了緊急通訊的便利，也會將一些方便發送且辨識的訊號賦予特殊意義，像是在國際上作為求救訊號的 <code>SOS</code> 就是一個知名的例子，該訊號會以「三短、三長、三短」簡單且易辨別的電碼序列發送。另一方面，為了縮短需要發送的電碼長度，也會透過將常用的語句進行縮寫，像是以 <code>RX</code> 代表 <code>Receive</code>、<code>SN</code> 作為 <code>Soon</code>、<code>SRI</code> 作為 <code>Sorry</code> 等等。 </p> <p> 摩斯電碼在歷史發展上歷經數次變革，主要有三種版本，第一個是由 Morce 提出的最初版本 American Morse，第二個是由 Gerke 修改過後用在德國鐵路上的 Continental 版本，第三種是以國際電信聯盟 (ITU) 所制定的 International 版本。本站的電碼是使用 ITU 制定的標準。 </p> </section> <section> <h3 class=\"title is-3\">書寫</h3> <p> 在慣例上，會使用點號 (dot) <code>.</code> 代表短音 (dit)、破折號 (dash) <code>-</code> 代表長音 (dah)、空白 (space) <code>&nbsp;</code> 代表區隔字母、符號的短停頓、斜線 (slash) <code>/</code> 代表單詞間的長停頓。如下方表格以 <code>Morse Code</code> 作為範例，依序將每個字母和空白轉成摩斯電碼，即可得到 <code>-- --- .-. ... . / -.-. --- -.. .</code> 的密文；同樣的，也可以將密文反解析為原文。 </p> <table class=\"table is-bordered has-text-centered\"> <thead> <tr> <th colspan=10>Morse Code</th> </tr> </thead> <tbody style=\"font-family: monospace\"> <tr> <td>M</td> <td>o</td> <td>r</td> <td>s</td> <td>e</td> <td>&nbsp;</td> <td>C</td> <td>o</td> <td>d</td> <td>e</td> </tr> <tr> <td>--</td> <td>---</td> <td>.-.</td> <td>...</td> <td>.</td> <td>/</td> <td>-.-.</td> <td>---</td> <td>-..</td> <td>.</td> </tr> <tr> <td colspan=10> -- --- .-. ... . / -.-. --- -.. . </td> </tr> </tbody> </table> </section> <section> <h3 class=\"title is-3\">參考資料</h3> <ul> <li> <a href=#> 本站開發記事 (待編寫) </a> </li> <li> <a href=https://en.wikipedia.org/wiki/Morse_code> 維基百科 - 摩斯電碼 (英文) </a> </li> <li> <a href=https://en.wikipedia.org/wiki/International_Telecommunication_Union> 維基百科 - 國際電信聯盟 (英文) </a> </li> <li> <a href=\"https://www.youtube.com/watch?v=lpCxnp20vhI\"> Youtube - Morse Code Song </a> </li> <li> <a href=\"https://www.youtube.com/watch?v=ncOcgarGJHI\"> Youtube - 摩斯電報發送教學 (日語、英文字幕) </a> </li> <li> <a href=http://morsecode.scphillips.com/translator.html> Morse Code Translator (英文) </a> </li> </ul> </section> </div> </div> </section> ";

/***/ },

/***/ 165:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(145)
	__vue_script__ = __webpack_require__(119)
	__vue_template__ = __webpack_require__(157)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 166:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(146)
	__vue_script__ = __webpack_require__(120)
	__vue_template__ = __webpack_require__(158)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 167:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(147)
	__vue_script__ = __webpack_require__(121)
	__vue_template__ = __webpack_require__(159)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 168:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(148)
	__vue_script__ = __webpack_require__(122)
	__vue_template__ = __webpack_require__(160)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 169:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(149)
	__vue_script__ = __webpack_require__(123)
	__vue_template__ = __webpack_require__(161)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 170:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_template__ = __webpack_require__(162)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 171:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_template__ = __webpack_require__(163)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },

/***/ 172:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(150)
	__vue_script__ = __webpack_require__(124)
	__vue_template__ = __webpack_require__(164)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.35f3e36e5bba608c5d98.js
 **/